import { BillingConstants } from './billing.constants'
import { IBillingAction, IBillingState } from './billing.types'

export const initialBillingState: IBillingState = {
  selectedOption: BillingConstants.INSURANCE_INFORMATION_OPTION,
}

export function BillingReducer(state: IBillingState = initialBillingState, action: IBillingAction): IBillingState {
  switch (action.type) {
    case BillingConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case BillingConstants.SET_SELECTED_OPTION:
      return { ...state, selectedOption: action.selectedOption }
    default:
      return state
  }
}
